
type PrimeBadgeProps = {
    cost: number;
    perSecond: number;
};

const PrimeBadge = ({ cost, perSecond }: PrimeBadgeProps) => {
    return <div className="flex items-center gap-1 w-fit rounded-full px-2 py-1 bg-badge-bg-inverse">
        <img src="/imgweb/main/neo_coin.png" alt="coin" className="h-3 w-3" />
        <div className="typography-caption-body text-base-txt-inverse">{cost ?? ''} / {perSecond}sec</div>
    </div>;
};

export default PrimeBadge;